import type {
  EmbedToWidgetMessage,
  ParentFontFace,
} from "@babackapp/return-widget-components/types/shop-now";

type WidgetFontMessage = EmbedToWidgetMessage & { type: "WIDGET_FONT" };

// Embed scripts cached on storefronts before `fontFaces` only send one file,
// registered without descriptors as before.
export function resolveParentFontFaces(msg: WidgetFontMessage): ParentFontFace[] {
  if (msg.fontFaces?.length) return msg.fontFaces;
  return msg.fontFaceUrl ? [{ url: msg.fontFaceUrl }] : [];
}

// Each face keeps its weight and style: without them a bold file declared
// first by the theme became the regular weight and every text rendered bold.
export function registerParentFont(msg: WidgetFontMessage): void {
  for (const { url, weight, style } of resolveParentFontFaces(msg)) {
    const face = new FontFace(msg.fontFamily, `url(${url})`, { weight, style });
    face.load().then((loaded) => document.fonts.add(loaded)).catch(() => {});
  }
}
